<div class="cov-public-application">
  <div class="cov-public-application-content m-4 m-lg-8">
    <!-- actual page content -->
    <router-outlet />
  </div>
  <div class="cov-public-application-footer ms-4 ms-lg-8">
    <cov-footer />
  </div>
</div>
